<script>
  import config from "../../stores/config";
  import axios from "axios";
  import { onMount } from "svelte";
  import FStyleRow from "./FStyleRow.svelte";
  import { Wave } from "svelte-loading-spinners";

  export let EDITABLE = false;
  export let orderID;
  export let customerID;

  let products = null;
  let queryURL = "";

  /* Query Parameters, just CHANGE them and the query will be regenerated as well, NO need to change everything */
  let page = 1;
  let searchKey = "";
  let sortBy = "";
  let sortOrder = "";

  /* Ordering */
  let tableOrder = "asc";

  const fetchFStyles = () => {
    products = null;

    queryURL = `${$config.backendURL}/fstyles/page/${page}?`;
    queryURL += `&searchKey=${searchKey || ""}`;
    queryURL += `&sortBy=${sortBy || "addedOn"}`;
    queryURL += `&sortOrder=${sortOrder || "desc"}`;
    queryURL += `&orderID=${orderID || ""}`;

    axios
      .get(queryURL)
      .then((res) => {
        products = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSort = (by) => {
    tableOrder = tableOrder == "asc" ? "desc" : "asc";
    sortBy = by;
    sortOrder = tableOrder;
    fetchFStyles();
  };

  const handlePrevPage = () => {
    if (page <= 1) page = 1;
    else {
      page = page - 1;
      fetchFStyles();
    }
  };
  const handleNextPage = () => {
    if (page <= 0) page = 0;
    page = page + 1;
    fetchFStyles();
  };

  const handleRefresh = () => {
    page = 1;
    searchKey = "";
    sortBy = "";
    sortOrder = "";
    fetchFStyles();
  };

  onMount(() => {
    fetchFStyles();
  });
</script>

{#if $config.currentUser}
  {#if $config.currentUser.department == "Management"}
    <!-- Search Bar -->
    <div class="flex justify-between">
      <div class="flex justify-center">
        <input
          bind:value={searchKey}
          on:input={fetchFStyles}
          class="shadow-sm"
          type="text"
          placeholder="Search here..."
        />
        <button class="ml-2 btn btn-primary" on:click={fetchFStyles}>
          <i class="fas fa-search" />
        </button>
      </div>
      <div class="flex items-center">
        <button class="btn btn-green mr-4" on:click={handleRefresh}>
          <i class="fas fa-undo mr-3" />
          Refresh
        </button>
      </div>
    </div>

    <!-- Products Bar -->
    <div
      class="mt-6 bg-white rounded-md shadow-sm w-full overflow-auto text-gray-500 text-sm"
    >
      <div class="th  border-b border-gray-100 font-semibold text-gray-600">
        <h1 style="min-width: 25rem; max-width: 25rem;">Actions</h1>
        <h1
          on:click={() => handleSort("name")}
          class="cursor-pointer"
          style="min-width: 20rem; max-width: 20rem;"
        >
          Name
        </h1>
        <h1
          on:click={() => handleSort("orderNumber")}
          class="cursor-pointer"
          style="min-width: 7.5rem; max-width: 7.5rem;"
        >
          Job Number
        </h1>
        <!-- <h1
          on:click={() => handleSort("price")}
          class="cursor-pointer"
          style="min-width: 7.5rem; max-width: 7.5rem;"
        >
          Selling Price
        </h1> -->
        <h1
          on:click={() => handleSort("class_")}
          class="cursor-pointer"
          style="min-width: 8.5rem; max-width: 8.5rem;"
        >
          Category
        </h1>
        <div
          class="cursor-not-allowed mr-4"
          style="min-width: 7.5rem; max-width: 7.5rem;"
        >
          Raw Mat. Cost
        </div>
        <div
          on:click={() => handleSort("inventoryLevel")}
          class="cursor-pointer"
          style="min-width: 5rem; max-width: 5rem;"
        >
          Quantity
        </div>
        <div
          on:click={() => handleSort("SKU")}
          class="cursor-pointer"
          style="min-width: 10rem; max-width: 10rem;"
        >
          SKU
        </div>
        <!-- <div
          on:click={() => handleSort("supplierID")}
          class="cursor-pointer"
          style="min-width: 7.5rem; max-width: 7.5rem;"
        >
          Total Value
        </div> -->
      </div>

      {#if products}
        {#each products as prod (prod._id)}
          <FStyleRow
            {EDITABLE}
            {...prod}
            {orderID}
            {customerID}
            on:delete={fetchFStyles}
            on:reloadData={fetchFStyles}
          />
        {:else}
          <div class="h-52 w-full flex items-center justify-center">
            Nothing to show...
          </div>
        {/each}
      {:else}
        <div class="h-52 w-full flex items-center justify-center">
          <Wave size="50" color="rgb(244,162,97)" unit="px" />
        </div>
      {/if}

      <div class="tf">
        <button
          class="text-base btn btn-gray-outline"
          on:click={handlePrevPage}
        >
          <i class="fas fa-arrow-alt-circle-left mr-3" />
          Prev Page
        </button>
        <div class="mx-4">Page {page}</div>
        <button
          class="text-base btn btn-gray-outline"
          on:click={handleNextPage}
        >
          Next Page
          <i class="fas fa-arrow-alt-circle-right ml-3" />
        </button>
      </div>
    </div>
  {/if}
{/if}

<style>
  .th,
  .tf {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 20px;
  }
</style>
